import React, { useReducer, useContext } from "react";
import { policyPlanTemplateReducer as reducer } from "../reducers/policyPlanTemplateReducer";
import { policyPlanTemplateActions as actions } from "../actions/policyPlanTemplateActions";

const policyPlanTemplateContext = React.createContext();

const PolicyPlanTemplateContext = ({ children }) => {
  const initialValue = {
    templates: null,
    currentTemplate: null,
  };

  const [state, dispatch] = useReducer(reducer, initialValue);

  return (
    <policyPlanTemplateContext.Provider value={{ state, dispatch, actions }}>
      {children}
    </policyPlanTemplateContext.Provider>
  );
};

export const usePolicyPlanTemplateContext = () =>
  React.useContext(policyPlanTemplateContext);
export default PolicyPlanTemplateContext;
